import React from 'react';
import TableCell from '@mui/material/TableCell';
import Typography from '@mui/material/Typography';
import { Collapse, TableRow } from '@mui/material';
import CardContent from '@mui/material/CardContent';
import Grid from '@mui/material/Grid';
import objectAccessor from '../util';
import { Transaction } from '../../../store/transactions/types';

interface ExpandableCell {
  id: string;
  label: string;
  accessor: string;
}

type expansionPanelProperties = {
  classes: any;
  expandableData: any;
  row: Transaction;
  col: number;
  open: boolean;
};

const renderDetails = (cells: [ExpandableCell], index: number, row: Transaction, classes: any) => {
  if (cells[index]) {
    return (
      <div className={classes.expandableRowText}>
        <Typography>{cells[index].label}: </Typography>
        <Typography className={classes.expandableRowValue}>
          {objectAccessor(row, cells[index].accessor)}
        </Typography>
      </div>
    );
  }
  return <></>;
};

const Accordion = (properties: expansionPanelProperties) => {
  const { expandableData, row, col, open, classes } = properties;

  return open ? (
    <TableRow className={classes.expandableRowContainer}>
      <TableCell colSpan={col + 2} className={classes.expandableRow}>
        <Collapse in={open}>
          <CardContent>
            <div className={classes.grid}>
              <Grid container spacing={3}>
                {expandableData.map((cellRows: { id: string }, index: number) => (
                  <Grid key={cellRows.id} item xs={4} style={{ padding: 2 }}>
                    {renderDetails(expandableData, index, row, classes)}
                  </Grid>
                ))}
              </Grid>
            </div>
          </CardContent>
        </Collapse>
      </TableCell>
    </TableRow>
  ) : null;
};

export default Accordion;
